$(".graphics-hover").on("mouseover", function (){
    $(".graph-2-large").addClass("active");
}).on("mouseleave", function (){
    $(".graph-2-large").removeClass("active");
})